export enum CommandPrefixes {
  TOKEN = 'CV:',
  NOTES = 'SN:',
  SETTINGS_UI = 'SUIC:',
  MANUAL_COLOR = 'MCT:',
  REACTION_FEEDBACK = 'RPF:',
  SUD = 'DAR:0,',
  VOC = 'DAR:1,',
  MEDIA_PRELOAD = 'MPLC:',
  MEDIA_PLAYBACK = 'MPBC:',
  MEDIA_VISIBILITY = 'MDC:',
  MEDIA_LOAD_STATUS_REPORT = 'MLSR:',
  USER_INTERACTION_MEDIA_REPORT = 'UMIR:',
  THEME_COMMAND = 'TC:',
  SHOW_MESSAGE_COMMAND = 'SMC:',
}
